export default "__VITE_ASSET__svrBR3C4__"